import { styled } from "@mui/material";

export const BaseLegend = styled("legend")(() => {
    return {
        fontFamily: "Inter",
        fontWeight: "700",
        fontSize: "30px",
        lineHeight: "normal",
        color: "#373737",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
})